import React from 'preact/compat';

import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Divider from '@mui/material/Divider'
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import StarIcon from '../icons/StarIcon';
import colors from '../colors';

export const TABS = {
    TAB_SERVICES: "TABS.TAB_SERVICES",
    TAB_FEATURES: "TABS.TAB_FEATURES",
    TAB_SELECTED: "TABS.TAB_SELECTED"
};

export const LauncherFeatureSelectorTabs = ({tab, handleTabChange, nSelected}) => {
    return <ToggleButtonGroup
        color="primary"
        value={tab}
        exclusive
        onChange={handleTabChange}
        aria-label="Tab"
        sx={{
            backgroundColor: colors.featureSelectorHeaderBackground,
            justifyContent: 'stretch',
            borderRadius: 0,
            flexWrap: 'no-wrap',
            position: 'relative',
            top: '-1px',
            left: '-1px',
            width: 'calc(100% + 2px)',
            borderBottomWidth: '1px',
            borderBottomColor: colors.featureSelectorBorder,
            borderBottomStyle: 'solid',
            height: '71px',
            boxSizing: 'border-box',
            '& .MuiButtonBase-root': {
                flexGrow: 1,
                background: 'none',
                outline: 'none',
                border: 'none',
                fontSize: {'sm': '24px', 'xs': '16px'},
                height: '70px',
                fontWeight: 600,
                textTransform: 'capitalize',
                color: colors.primaryText,
                overflow: 'hidden',
                '&.Mui-selected': {
                    color: colors.option,
                    borderWidth: '1px',
                    borderColor: colors.featureSelectorBorder,
                    borderStyle: 'solid',
                    borderBottomColor: colors.featureSelectorBackground,
                    backgroundColor: colors.featureSelectorBackground,
                    borderRadius: 0,
                    borderTopLeftRadius: '8px',
                    borderTopRightRadius: '8px',
                    height: '71px',
                },
                '&.Mui-selected:hover, &:hover': {
                    backgroundColor: colors.optionHover + '10'
                },
                '& .selectedBox': {
                    backgroundColor: colors.featureBackground,
                    color: colors.featureText,
                    fontWeight: 700,
                    height: '30px',
                    fontSize: {'sm': '16px', 'xs': '10px'},
                    paddingLeft: '16px',
                    paddingRight: '16px',
                    borderRadius: '8px',
                    marginLeft: '16px',
                    alignItems: 'center',
                    '& svg': {
                        fontSize: {'sm': '16px', 'xs': '10px'},
                        marginRight: '5px'
                    },
                    '& .MuiBox-root': {
                        paddingTop: {'sm': '4px', 'xs': '2px'}
                    }
                }
            },
            '& .MuiDivider-root': {
                borderColor: colors.featureSelectorBorder,
                borderRightWidth: '1px',
                borderRadius: 0,
                height: '55px',
                alignSelf: 'center'
            }
        }}
    >
        <ToggleButton value={TABS.TAB_SERVICES}>
            Cloud Services
        </ToggleButton>
        {tab === TABS.TAB_SELECTED && <Divider orientation="vertical" flexItem />}
        <ToggleButton value={TABS.TAB_FEATURES}>
            Features
        </ToggleButton>
        {tab === TABS.TAB_SERVICES && <Divider orientation="vertical" flexItem />}
        <ToggleButton value={TABS.TAB_SELECTED}>
            Selected
            <Stack direction="row" className="selectedBox">
                <StarIcon />
                <Box> {nSelected} </Box>
            </Stack>
        </ToggleButton>
    </ToggleButtonGroup>
};

export default LauncherFeatureSelectorTabs;
